var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "grid-template-frontend" },
        _vm._l(_vm.widgetSettings.layoutSettings, function (col, index) {
          return _c(
            "div",
            { key: index, staticClass: "row" },
            [
              col === 1
                ? [
                    _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                      _vm.getCardItem(col, index, 1) != null
                        ? _c(
                            "div",
                            { staticClass: "card-item" },
                            [
                              _c("card-item", {
                                attrs: {
                                  "card-content": _vm.getCardItem(
                                    col,
                                    index,
                                    1
                                  ),
                                  filestore: _vm.filestore,
                                  "grid-size": "full",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              col === 1.2
                ? [
                    _c("div", { staticClass: "col-xs-12 col-sm-12 col-md-4" }, [
                      _vm.getCardItem(col, index, 1) != null
                        ? _c(
                            "div",
                            { staticClass: "card-item" },
                            [
                              _c("card-item", {
                                attrs: {
                                  "card-content": _vm.getCardItem(
                                    col,
                                    index,
                                    1
                                  ),
                                  filestore: _vm.filestore,
                                  "grid-size": "one-third",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-sm-12 col-md-8" }, [
                      _vm.getCardItem(col, index, 2) != null
                        ? _c(
                            "div",
                            { staticClass: "card-item" },
                            [
                              _c("card-item", {
                                attrs: {
                                  "card-content": _vm.getCardItem(
                                    col,
                                    index,
                                    2
                                  ),
                                  filestore: _vm.filestore,
                                  "grid-size": "two-third",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              col === 2
                ? [
                    _vm._l(col, function (iter) {
                      return [
                        _c(
                          "div",
                          {
                            key: iter,
                            staticClass: "col-xs-12 col-sm-12 col-md-6",
                          },
                          [
                            _vm.getCardItem(col, index, iter) != null
                              ? _c(
                                  "div",
                                  { staticClass: "card-item" },
                                  [
                                    _c("card-item", {
                                      attrs: {
                                        "card-content": _vm.getCardItem(
                                          col,
                                          index,
                                          iter
                                        ),
                                        filestore: _vm.filestore,
                                        "grid-size": "one-half",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              col === 2.1
                ? [
                    _c("div", { staticClass: "col-xs-12 col-sm-12 col-md-8" }, [
                      _vm.getCardItem(col, index, 2) != null
                        ? _c(
                            "div",
                            { staticClass: "card-item" },
                            [
                              _c("card-item", {
                                attrs: {
                                  "card-content": _vm.getCardItem(
                                    col,
                                    index,
                                    1
                                  ),
                                  filestore: _vm.filestore,
                                  "grid-size": "two-third",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-sm-12 col-md-4" }, [
                      _vm.getCardItem(col, index, 2) != null
                        ? _c(
                            "div",
                            { staticClass: "card-item" },
                            [
                              _c("card-item", {
                                attrs: {
                                  "card-content": _vm.getCardItem(
                                    col,
                                    index,
                                    2
                                  ),
                                  filestore: _vm.filestore,
                                  "grid-size": "one-third",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              col === 3
                ? [
                    _vm._l(col, function (iter) {
                      return [
                        _c(
                          "div",
                          {
                            key: iter,
                            staticClass: "col-xs-12 col-sm-12 col-md-4",
                          },
                          [
                            _vm.getCardItem(col, index, iter) != null
                              ? _c(
                                  "div",
                                  { staticClass: "card-item" },
                                  [
                                    _c("card-item", {
                                      attrs: {
                                        "card-content": _vm.getCardItem(
                                          col,
                                          index,
                                          iter
                                        ),
                                        filestore: _vm.filestore,
                                        "grid-size": "one-third",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    }),
                  ]
                : _vm._e(),
            ],
            2
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }